import { Action, Reducer, ReducersMapObject } from 'redux';

export function createReducer<TState, TActionType extends string>(
  initialState: TState,
  handlers: { [T in TActionType]: (state: TState, action: Action) => TState }
) {
  return function reducer(state: TState = initialState, action: Action) {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  };
}

export function combineReducersWithRoot<S extends Object>(
  rootReducer: Reducer<S>,
  reducers: ReducersMapObject
): Reducer<S> {
  return (state: S, action: Action) => {
    let newState: S = rootReducer(state, action);
    // Ensure the root state object is a new object; otherwise
    // React may not re-render.
    // let newState = { ...rootReducer(state, action) };
    newState = Object.assign({}, newState);
    Object.keys(reducers).forEach(domain => {
      let obj = state ? state[domain] : undefined;
      newState[domain] = reducers[domain](obj, action);
    });
    return newState;
  };
}



// WEBPACK FOOTER //
// ./src/common/redux-utils.ts